const INVALID_NAME_PATTERN = /^(null|undefined|\?+|n\/?a|-|—|none|unknown|anonymous)$/i;

function toTrimmedString(value) {
  if (value == null) return '';
  return String(value).trim();
}

/**
 * Returns a usable display string, or '' for blank / placeholder values.
 */
export function sanitizeDisplayValue(value) {
  const trimmed = toTrimmedString(value);
  if (!trimmed) return '';
  if (INVALID_NAME_PATTERN.test(trimmed)) return '';
  return trimmed;
}

export function firstNonEmpty(...values) {
  for (const value of values) {
    const sanitized = sanitizeDisplayValue(value);
    if (sanitized) return sanitized;
  }
  return '';
}

/**
 * Best-effort phone from list/detail payloads (API field variants).
 */
export function getConversationPhone(user) {
  if (!user || typeof user !== 'object') return '';

  return firstNonEmpty(
    user.phone_number,
    user.phone,
    user.mobile,
    user.wa_id,
    user.customer_number,
    user.last_message?.phone_number,
    user.last_message?.from,
    user.last_message?.wa_id
  );
}

/**
 * Prefer WhatsApp/profile name; fall back to mobile number.
 */
export function getConversationDisplayName(user, fallback = 'Unknown') {
  if (!user || typeof user !== 'object') return fallback;

  const name = firstNonEmpty(
    user.whatsapp_name,
    user.name,
    user.user_name,
    user.profile_name,
    user.contact_name
  );

  return name || getConversationPhone(user) || fallback;
}

/**
 * Avatar letter: name initial, else last digit of phone, else '?'.
 */
export function getConversationAvatarInitial(userOrName) {
  if (userOrName && typeof userOrName === 'object') {
    const name = firstNonEmpty(
      userOrName.whatsapp_name,
      userOrName.name,
      userOrName.user_name,
      userOrName.profile_name,
      userOrName.contact_name
    );
    if (name) return name.charAt(0).toUpperCase();

    const phone = getConversationPhone(userOrName);
    if (phone) {
      const digits = phone.replace(/\D/g, '');
      return (digits.slice(-1) || phone.charAt(0)).toUpperCase();
    }
    return '?';
  }

  const label = sanitizeDisplayValue(userOrName);
  if (!label) return '?';
  if (/^\+?\d[\d\s-]*$/.test(label)) {
    const digits = label.replace(/\D/g, '');
    return (digits.slice(-1) || label.charAt(0)).toUpperCase();
  }
  return label.charAt(0).toUpperCase();
}
